export const availValidationData = (payload) => {
  let errors = []

  if (!payload?.destination?._id && payload?.type === 'hotels')
    errors.push({
      type: 'keyword',
      message: 'Destino es requerido2'
    })
  if (!payload?.countryCode || !payload?.country)
    errors.push({
      type: 'nationality',
      message: 'Nacionalidad es requerida'
    })
  if (!payload?.start || !payload?.end)
    errors.push({
      type: 'checking',
      message: 'Checking es requerido'
    })

  if (!payload?.totalNumberOfPeople)
    errors.push({
      type: 'rooms',
      message: 'Número de personas es requerido'
    })

  return {
    errors: errors.length ? true : false,
    data: errors
  }
}
